/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationSettingsSettings } from './NotificationSettingsSettings';
import {
    NotificationSettingsSettingsFromJSON,
    NotificationSettingsSettingsFromJSONTyped,
    NotificationSettingsSettingsToJSON,
    NotificationSettingsSettingsToJSONTyped,
} from './NotificationSettingsSettings';

/**
 * Payload to create notification settings
 * @export
 * @interface CreateNotificationSettingsRequest
 */
export interface CreateNotificationSettingsRequest {
    /**
     * 
     * @type {NotificationSettingsSettings}
     * @memberof CreateNotificationSettingsRequest
     */
    settings?: NotificationSettingsSettings;
}

/**
 * Check if a given object implements the CreateNotificationSettingsRequest interface.
 */
export function instanceOfCreateNotificationSettingsRequest(value: object): value is CreateNotificationSettingsRequest {
    return true;
}

export function CreateNotificationSettingsRequestFromJSON(json: any): CreateNotificationSettingsRequest {
    return CreateNotificationSettingsRequestFromJSONTyped(json, false);
}

export function CreateNotificationSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNotificationSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'settings': json['settings'] == null ? undefined : NotificationSettingsSettingsFromJSON(json['settings']),
    };
}

export function CreateNotificationSettingsRequestToJSON(json: any): CreateNotificationSettingsRequest {
    return CreateNotificationSettingsRequestToJSONTyped(json, false);
}

export function CreateNotificationSettingsRequestToJSONTyped(value?: CreateNotificationSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'settings': NotificationSettingsSettingsToJSON(value['settings']),
    };
}

